export default "__VITE_ASSET__C_V2zeFT__"